export const SearchQueryKeys = [
  'locations',
  'boundingBox',
  'polygons',
  'surroundingSuburbs',
  'propertyStatus',
  'minPrice',
  'maxPrice',
  'propertyTypes',
  'minBedrooms',
  'minBathrooms',
  'minLandSize',
  'minCarSpaces',
  'indoorFeatures',
  'outdoorFeatures',
  'ecoFriendlyFeatures',
  'keywords',
  'excludeUnderOffer',
  'hasImages',
  'excludeDepositTaken',
  'view',
  'flow',
  'commutes',
  'sortOption',
  'zoomLevel',
  'pageNumber',
  'findSimilar',
] as const;
export type SearchQueryKeys = (typeof SearchQueryKeys)[number];
